import { useEffect, useState } from "react";
import { CountryTransfert } from "../../utils/database";
import { countryTransfertService } from "../../services/countryTransfertService";
import useToken from "../../../../hooks/auth/useToken";

interface Props {}

export default function useCountryTransferts({}: Props) {
  const [countryTransferts, setCountryTransferts] = useState<CountryTransfert[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();

  const createCountryTransfert = async (data: {
    country_sender_id: number;
    country_destination_id: number;
    rate: string;
  }) => {
    try {
      await countryTransfertService.createCountryTransfert(token, data);
      getCountryTransferts();
    } catch (error) {
      throw error;
    }
  };

  const getCountryTransferts = async () => {
    setLoading(true);
    try {
      const data = await countryTransfertService.getCountryTransferts(100, 0);
      setCountryTransferts(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const deleteCountryTransfert = async (id: string) => {
    try {
      await countryTransfertService.deleteCountryTransfert(token, id);
      getCountryTransferts();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const updateCountryTransfert = async (
    id: any,
    data: { country_sender_id?: number; country_destination_id?: number; rate?: string }
  ) => {
    if (!id) {
      alert("Une erreur s'est produite");
      return;
    }
    try {
      await countryTransfertService.updateCountryTransfert(token, id, data);
      getCountryTransferts();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  useEffect(() => {
    getCountryTransferts();
  }, [token]);

  return {
    countryTransferts,
    getCountryTransferts,
    length: countryTransferts.length,
    countryTransfertsLoading: loading,
    countryTransfertsError: error,
    deleteCountryTransfert,
    updateCountryTransfert,
    createCountryTransfert,
  };
}
